import React from "react";
import HeroSection from "./Sections/HeroSection";
import Navbar from "../components/Navbar";
const Home = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
    </>
  );
};

export default Home;
